import React from "react";
import "./ArtSection.css";
import maskGroupImg from "../../../../assets/images/Mask_group.png";
import artBg from "../../../../assets/images/golden_floating_wavy_shapes_vector.png";

const ArtSection = () => {
  return (
    <section className="art-section" style={{ backgroundImage: `url(${artBg})`, backgroundSize: 'cover', backgroundPosition: 'left 10%', backgroundRepeat: 'no-repeat' }}>
      <div className="art-container">

        {/* Left Side: Content Area */}
        <div className="art-content">
          <h2 className="art-heading">THE ART BEHIND EVERY BLOUSE</h2>

          <div className="art-description">
            <p>
              At Yug Mantra by Siddharth Fashion, we believe fashion is more than
              clothing—it's a reflection of personality, confidence, and tradition. Every
              creation is thoughtfully designed to blend contemporary trends with
              timeless craftsmanship.
            </p>
            <p>
              From exclusive ethnic wear and occasion outfits to personalized styling, we
              focus on delivering exceptional quality, impeccable fit, and distinctive
              designs that make every moment special.
            </p>
            <p>
              Backed by the trusted legacy of Siddharth Fashion, Yug Mantra brings a
              fresh perspective to modern ethnic fashion while staying rooted in elegance
              and authenticity.
            </p>
          </div>

          <p className="art-signature">
            Crafted with Tradition. Styled for Today.
          </p>
        </div>

        {/* Right Side: Showcase Image */}
        <div className="art-image-area">
          <div className="art-image-wrapper">
            <img
              src={maskGroupImg}
              alt="The Art Behind Every Blouse"
              className="art-main-img"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default ArtSection;
